import React from 'react';
import { useTranslation } from 'react-i18next';
import ViewDashboardOutlineIcon from 'mdi-react/ViewDashboardOutlineIcon';
import OfficeBuildingOutlineIcon from 'mdi-react/OfficeBuildingOutlineIcon';
import DomainIcon from 'mdi-react/DomainIcon';
import ChartBarIcon from 'mdi-react/ChartBarIcon';
import AccountCheckOutlineIcon from 'mdi-react/AccountCheckOutlineIcon';
import AccountPlusOutlineIcon from 'mdi-react/AccountPlusOutlineIcon';
import ShieldAccountOutlineIcon from 'mdi-react/ShieldAccountOutlineIcon';
import LogoutIcon from 'mdi-react/LogoutIcon';
import { Navigation, type LinkMenuItem, type ParentMenuItem } from '../navigation/navigation.component';
import AppConstants from '../../app.constants';
import RouteConstants from '../../routes.constants';
import { useKeycloak } from '../../../features/authentication/keycloak/KeycloakProvider';

interface Props {
  readonly open: boolean;
  readonly closeMenu: () => void;
}

const Menu = ({ open, closeMenu }: Props): React.JSX.Element => {
  const { t } = useTranslation();
  const items: Array<LinkMenuItem | ParentMenuItem> = [];
  const keycloak = useKeycloak();

  if (keycloak.hasRealmRole(AppConstants.WHYELLOW_ROLE)) {
    items.push({
      title: t('dashboard'),
      path: RouteConstants.PATH_DASHBOARD,
      activePath: `/${RouteConstants.PATH_DASHBOARD}`,
      icon: ViewDashboardOutlineIcon,
    });
  }

  if (keycloak.hasRealmRole(AppConstants.WHYELLOW_ROLE) || keycloak.hasRealmRole(AppConstants.ADMIN_ROLE)) {
    items.push({
      title: t('my-offices'),
      path: RouteConstants.PATH_OFFICES,
      activePath: `/${RouteConstants.PATH_OFFICES}`,
      icon: OfficeBuildingOutlineIcon,
    });
  }

  if (keycloak.hasRealmRole(AppConstants.WHYELLOW_ROLE)) {
    items.push({
      title: t('companies'),
      path: RouteConstants.PATH_COMPANIES,
      activePath: `/${RouteConstants.PATH_COMPANIES}`,
      icon: DomainIcon,
    });
  }

  if (
    keycloak.hasRealmRole(AppConstants.WHYELLOW_ROLE) ||
    keycloak.hasRealmRole(AppConstants.ADMIN_ROLE) ||
    keycloak.hasRealmRole(AppConstants.OFFICEMANAGER_ROLE)
  ) {
    items.push({
      title: t('statistics'),
      path: RouteConstants.PATH_STATISTICS,
      activePath: `/${RouteConstants.PATH_STATISTICS}`,
      icon: ChartBarIcon,
    });
  }
  if (keycloak.hasRealmRole(AppConstants.WHYELLOW_ROLE) || keycloak.hasRealmRole(AppConstants.OFFICEMANAGER_ROLE)) {
    items.push({
      title: t('check-in-employees'),
      path: RouteConstants.PATH_REGISTER_EMPLOYEES,
      activePath: `/${RouteConstants.PATH_REGISTER_EMPLOYEES}`,
      icon: AccountCheckOutlineIcon,
    });
  }

  if (keycloak.hasRealmRole(AppConstants.WHYELLOW_ROLE)) {
    items.push({
      title: t('register'),
      path: RouteConstants.PATH_REGISTER,
      activePath: `/${RouteConstants.PATH_REGISTER}`,
      icon: AccountPlusOutlineIcon,
    });
  }

  if (keycloak.hasRealmRole(AppConstants.WHYELLOW_ROLE) || keycloak.hasRealmRole(AppConstants.ADMIN_ROLE)) {
    items.push({
      title: t('register-office-managers'),
      path: RouteConstants.PATH_REGISTER_OFFICEMANAGERS,
      activePath: `/${RouteConstants.PATH_REGISTER_OFFICEMANAGERS}`,
      icon: ShieldAccountOutlineIcon,
    });
  }

  const logoutItem: LinkMenuItem = {
    title: t('log-out'),
    path: RouteConstants.PATH_ROOT,
    activePath: 'logout',
    icon: LogoutIcon,
  };

  return <Navigation open={open} items={items} logoutItem={logoutItem} closeMenu={closeMenu} />;
};

export default Menu;
